import { useTranslation } from "react-i18next";
import { Alert } from "@myphx-engineering/phx-design-system";
import { jsx } from "react/jsx-runtime";

//#region src/components/SystemDegradationBanner.tsx
const SystemDegradationBanner = ({ systemDegradationStatus }) => {
	const { t } = useTranslation("maintenance");
	const { isActive, message, alertLevel } = systemDegradationStatus;
	if (!isActive) return null;
	return /* @__PURE__ */ jsx(Alert, {
		severity: alertLevel,
		children: message ?? t("systemDegradation.defaultMessage")
	});
};

//#endregion
export { SystemDegradationBanner };